import { isNative } from "./nativeHttp";
import { saveBlob } from "./archivedFile";

// The paid document is generated on the success page but downloaded by the
// app once the success animation has finished and the app is back on
// screen. On phone browsers the file opens in a new tab so the app tab is
// never replaced by the PDF; elsewhere it downloads in place.

let pending = null;   // { blob, fileName, url } waiting for the app
let delivered = null; // the last one handed out (the ready toast's Download button re-opens it)

export function setPendingDownload(blob, fileName) {
  if (!blob) return;
  pending = { blob, fileName: fileName || "document.pdf", url: URL.createObjectURL(blob) };
}

export function takePendingDownload() {
  const p = pending;
  pending = null;
  return p;
}

export const isMobileBrowser = () =>
  !isNative && typeof navigator !== "undefined" && /iPhone|iPad|iPod|Android/i.test(navigator.userAgent || "");

const isPdfFile = (blob, name) =>
  (blob && typeof blob.type === "string" && blob.type.includes("pdf")) || /\.pdf$/i.test(name || "");

// A new tab (never this one). A PDF opens to view — no download attribute,
// so the browser shows it and the app tab stays put; anything else (a ZIP)
// keeps the attribute and saves from the new tab.
export function openDownloadInNewTab({ url, fileName }) {
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener";
  if (!/\.pdf$/i.test(fileName || "")) a.download = fileName || "document.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

// Called by the app once it is on screen again. Returns what was delivered
// (or null) so the caller can offer a Download button as well.
export function deliverPendingDownload() {
  const p = takePendingDownload();
  if (!p) return null;
  // single PDFs open in a new tab everywhere; ZIPs download in place on
  // desktop and via the new tab on phones; native saves through the app
  if (!isNative && isPdfFile(p.blob, p.fileName)) openDownloadInNewTab(p);
  else if (isMobileBrowser()) openDownloadInNewTab(p);
  else saveBlob(p.blob, p.fileName);
  delivered = p;
  setTimeout(() => { if (delivered === p) { delivered = null; try { URL.revokeObjectURL(p.url); } catch {} } }, 10 * 60 * 1000);
  return p;
}

export const lastDeliveredDownload = () => delivered;

// Hand a finished document straight to the browser. Same rule as the paid
// flow: a new tab on phone browsers, so the app's tab is never replaced by the
// PDF, and in place everywhere else.
export function deliverDownload(blob, fileName) {
  if (!blob) return;
  const name = fileName || "document.pdf";
  if (!isNative && isPdfFile(blob, name)) openDownloadInNewTab({ url: URL.createObjectURL(blob), fileName: name });
  else if (isMobileBrowser()) openDownloadInNewTab({ url: URL.createObjectURL(blob), fileName: name });
  else saveBlob(blob, name);
}
